const pinpollConfig = {
  sizeMappings: {
    REC: [
      {
        viewPortSize: [0, 0],
        sizes: [[300, 250]],
      },
    ],
  },
  slots: [
    {
      id: 'dynamic-ad-container',
      globalId: 'pinpoll_1',
      path: '/2273514/fa_pinpoll_1',
      sizeMappingName: 'REC',
    },
  ],
  general: {
    reloadInterval: true,
    collapseEmptyDivs: true,
    disableInitialLoad: true,
    enableSingleRequest: true,
    preloadedFiles: [
      {
        link: 'https://securepubads.g.doubleclick.net/tag/js/gpt.js',
        async: true,
      },
    ],
    prebid: {
      active: true,
    },
    amazontam: true,
  },
}

export default pinpollConfig
